// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.low {
  height: calc(100vh - 190px);
  overflow: auto;
}

.high {
  height: calc(100vh - 260px);
  overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/app/common/loginlog/loginlog.component.scss"],"names":[],"mappings":"AAAA;EACI,2BAAA;EACA,cAAA;AACJ;;AACA;EACI,2BAAA;EACA,cAAA;AAEJ","sourcesContent":[".low{\r\n    height: calc(100vh - 190px);\r\n    overflow: auto;\r\n}\r\n.high{\r\n    height: calc(100vh - 260px);\r\n    overflow: auto;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
